module.exports = __webpack_public_path__ + "static/assets/46e50ff4b8e02230fe12cffbff9c97a6.svg";